import { useState } from "react"
import { uploadExpenseFiles } from "./useOrganizationExpenses"

const useAttachedFiles = (
  initialFiles = [],
  { organizationId, expenseId, createdByProject } = {},
) => {
  const [attachedFiles, setAttachedFiles] = useState(initialFiles)
  const [loadingFiles, setLoadingFiles] = useState({})

  const handleFileSelect = () => {
    const fileInput = document.createElement("input")
    fileInput.type = "file"
    fileInput.multiple = true
    fileInput.accept =
      ".jpg,.jpeg,.png,.pdf,image/jpeg,image/png,application/pdf"
    fileInput.onchange = async event => {
      const files = Array.from(event.target.files)
      for (const file of files) {
        const id = Date.now() + Math.random()
        const newFile = {
          id,
          name: file.name,
          size: file.size,
          extension: file.name.split(".").pop(),
          file: file,
          isUploading: true,
        }
        setAttachedFiles(prev => [...prev, newFile])
        setLoadingFiles(prev => ({ ...prev, [id]: true }))

        if (organizationId && expenseId) {
          try {
            await uploadExpenseFiles({
              organizationId,
              expenseId,
              files: [file],
              createdByProject,
            })
            setAttachedFiles(prev =>
              prev.map(f => (f.id === id ? { ...f, isUploading: false } : f)),
            )
          } catch (e) {
            setAttachedFiles(prev =>
              prev.map(f =>
                f.id === id
                  ? { ...f, isUploading: false, uploadError: true }
                  : f,
              ),
            )
          }
        } else {
          setAttachedFiles(prev =>
            prev.map(f => (f.id === id ? { ...f, isUploading: false } : f)),
          )
        }
        setLoadingFiles(prev => ({ ...prev, [id]: false }))
      }
    }
    fileInput.click()
  }

  const handleRemoveFile = fileId => {
    setAttachedFiles(prev => prev.filter(file => file.id !== fileId))
  }

  const handleDownloadFile = file => {
    const url = URL.createObjectURL(file.file)
    const link = document.createElement("a")
    link.href = url
    link.download = file.name
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  const formatFileSize = bytes => {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const sizes = ["Bytes", "KB", "MB", "GB"]
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i]
  }

  const clearFiles = () => {
    setAttachedFiles([])
  }

  return {
    attachedFiles,
    handleFileSelect,
    handleRemoveFile,
    handleDownloadFile,
    formatFileSize,
    clearFiles,
    setAttachedFiles,
    loadingFiles,
  }
}

export default useAttachedFiles
